'use client';

import {
  PopoverContent,
  Root as PopoverRoot,
  PopoverTrigger,
} from '@radix-ui/react-popover';
import { joinClassNames } from '@vertex-protocol/web-common';
import { Button, Icons } from '@vertex-protocol/web-ui';
import { TutorialFlowAccordion } from 'client/modules/tutorial/components/TutorialFlowAccordion/TutorialFlowAccordion';
import { TutorialFlowHeader } from 'client/modules/tutorial/components/TutorialFlowHeader';
import { TutorialFlowSuccessContent } from 'client/modules/tutorial/components/TutorialFlowSuccessContent';
import { useUserTutorialFlow } from 'client/modules/tutorial/hooks/useUserTutorialFlow';

export function TutorialFlowPopover() {
  const {
    steps,
    performStep,
    skipStep,
    onDismissFlow,
    setIsExpanded,
    setActiveStepId,
    isExpanded,
    isCompleted,
    completedStepIds,
    activeStepId,
    shouldShowTutorialFlow,
  } = useUserTutorialFlow();

  // "Get started" button removed from footer bar
  return null;
}
